import { Checkbox, CheckboxChangeEvent, Form } from "antd";
import React from "react";
import "./FormItemCheckbox.scss";

interface FormItemCheckboxProps {
  name: string;
  label: string;
  rules: { required: boolean; message?: string };
  disabled?: boolean;
  isSettingInput?: boolean;
  onChangeFunction?: (e: CheckboxChangeEvent) => void;
}

const FormItemCheckbox: React.FC<FormItemCheckboxProps> = ({
  name,
  rules,
  label,
  disabled,
  isSettingInput,
  onChangeFunction,
}) => {
  return (
    <Form.Item
      className={`form-item__checkbox ${isSettingInput ? "setting" : ""}`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
      valuePropName="checked"
    >
      <Checkbox className={"checkbox"} onChange={onChangeFunction} disabled={disabled} />
    </Form.Item>
  );
};

export default FormItemCheckbox;
